export const FETCH_EMPLOYEE_REQUEST = "FETCH_EMPLOYEE_REQUEST";
export const FETCH_EMPLOYEE_SUCCESS = "FETCH_EMPLOYEE_SUCCESS";
export const FETCH_EMPLOYEE_FAILURE = "FETCH_EMPLOYEE_FAILURE";

export const FETCH_EMPLOYEE_DETAILS_REQUEST = "FETCH_EMPLOYEE_DETAILS_REQUEST";
export const FETCH_EMPLOYEE_DETAILS_SUCCESS = "FETCH_EMPLOYEE_DETAILS_SUCCESS";
export const FETCH_EMPLOYEE_DETAILS_FAILURE = "FETCH_EMPLOYEE_DETAILS_FAILURE";

export const FETCH_EMPLOYEE_OTHER_INFO_REQUEST = "FETCH_EMPLOYEE_OTHER_INFO_REQUEST";
export const FETCH_EMPLOYEE_OTHER_INFO_SUCCESS = "FETCH_EMPLOYEE_OTHER_INFO_SUCCESS";
export const FETCH_EMPLOYEE_OTHER_INFO_FAILURE = "FETCH_EMPLOYEE_OTHER_INFO_FAILURE";

export const FETCH_EMPLOYEE_NO_PAY_REQUEST = "FETCH_EMPLOYEE_NO_PAY_REQUEST";
export const FETCH_EMPLOYEE_NO_PAY_SUCCESS = "FETCH_EMPLOYEE_NO_PAY_SUCCESS";
export const FETCH_EMPLOYEE_NO_PAY_FAILURE = "FETCH_EMPLOYEE_NO_PAY_FAILURE";

export const FETCH_EMPLOYEE_PRE_YEAR_SUMMARY_REQUEST = "FETCH_EMPLOYEE_PRE_YEAR_SUMMARY_REQUEST";
export const FETCH_EMPLOYEE_PRE_YEAR_SUMMARY_SUCCESS = "FETCH_EMPLOYEE_PRE_YEAR_SUMMARY_SUCCESS";
export const FETCH_EMPLOYEE_PRE_YEAR_SUMMARY_FAILURE = "FETCH_EMPLOYEE_PRE_YEAR_SUMMARY_FAILURE";

export const FETCH_CDL_ENG_REQUEST = "FETCH_CDL_ENG_REQUEST";
export const FETCH_CDL_ENG_SUCCESS = "FETCH_CDL_ENG_SUCCESS";
export const FETCH_CDL_ENG_FAILURE = "FETCH_CDL_ENG_FAILURE";

export const FETCH_CDL_SUP_REQUEST = "FETCH_CDL_SUP_REQUEST";
export const FETCH_CDL_SUP_SUCCESS = "FETCH_CDL_SUP_SUCCESS";
export const FETCH_CDL_SUP_FAILURE = "FETCH_CDL_SUP_FAILURE";

export const FETCH_EMPLOYEE_ATTENDANCE_REQUEST = "FETCH_EMPLOYEE_ATTENDANCE_REQUEST";
export const FETCH_EMPLOYEE_ATTENDANCE_SUCCESS = "FETCH_EMPLOYEE_ATTENDANCE_SUCCESS";
export const FETCH_EMPLOYEE_ATTENDANCE_FAILURE = "FETCH_EMPLOYEE_ATTENDANCE_FAILURE";